import { render, staticRenderFns } from "./CustomMentionSectionBloc.vue?vue&type=template&id=59809e2e&"
import script from "./CustomMentionSectionBloc.vue?vue&type=script&lang=js&"
export * from "./CustomMentionSectionBloc.vue?vue&type=script&lang=js&"
import style0 from "./CustomMentionSectionBloc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports